<template>
  <div class="reset">
    <div class="reset__title">
      <p>Сброс пароля</p>
      <span>Введите новый пароль для аккаунта {{ emailDisplay }}</span>
    </div>
    <div>
      <input type="password" placeholder="Новый пароль" v-model="password" />
      <template v-for="(error) of v$.password.$errors" :key="error">
        <p class="errorValid">{{ error.$message }}</p>
      </template>
    </div>
    <div>
      <input type="password" placeholder="Подтверждение пароля" v-model="passwordConfirmation" />
      <template v-for="(error) of v$.passwordConfirmation.$errors" :key="error">
        <p class="errorValid">{{ error.$message }}</p>
      </template>
    </div>
    <button @click="submit" :disabled="loading">{{ loading ? 'Сохранение...' : 'Сохранить' }}</button>
    <router-link class="reset__back" to="/">Вернуться ко входу</router-link>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, helpers } from "@vuelidate/validators";
import { toast } from "vue3-toastify";
import { API_BASE_URL } from '@/config/api';

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      v$: useVuelidate(),
      email: '',
      token: '',
      password: '',
      passwordConfirmation: '',
      loading: false,
    };
  },
  computed: {
    emailDisplay() {
      return this.email || 'вашего аккаунта';
    }
  },
  validations() {
    return {
      password: {
        required: helpers.withMessage('Обязательное поле', required),
        minLength: helpers.withMessage('Минимум 6 символов', minLength(6)),
      },
      passwordConfirmation: {
        required: helpers.withMessage('Обязательное поле', required),
        sameAsPassword: helpers.withMessage('Пароли должны совпадать', (value, siblings) => {
          const target = (siblings?.password || '').trim();
          const candidate = (value || '').trim();
          return candidate === target;
        }),
      }
    };
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    this.token = params.get('token') || '';
    this.email = params.get('email') || '';
  },
  methods: {
    async submit() {
      this.v$.$validate();
      if (this.v$.$invalid) return;
      if (!this.token || !this.email) {
        toast.error('Недействительная ссылка сброса. Проверьте email.');
        return;
      }
      this.loading = true;
      try {
        const password = (this.password || '').trim();
        const passwordConfirmation = (this.passwordConfirmation || '').trim();
        const body = {
          email: this.email,
          token: this.token,
          password,
          password_confirmation: passwordConfirmation,
        };
        const res = await this.$axios.post(`${API_BASE_URL}/password/reset`, body);
        toast.success(res.data?.message || 'Пароль успешно изменен!');
        this.$router.push('/');
      } catch (e) {
        const msg = e?.response?.data?.message || 'Не удалось изменить пароль.';
        toast.error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.errorValid {
  font-size: 10px !important;
  color: #FF2A62 !important;
}
.reset {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  gap: 20px;
  &__title {
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #909090;
    }
  }
  div {
    input {
      border-bottom: 1px solid #1F50F180 !important;
      border: none;
      outline: none;
      padding: 5px;
      &::placeholder {
        color: #90909080;
      }
      width: 100%;
    }
  }
  button {
    background: #1965EA;
    border: none;
    border-radius: 5px;
    color: white;
    padding: 7px 0px;
    width: 200px;
    cursor: pointer;
    &:hover {
      background: #1557c9;
      transition: all 0.3s ease;
    }
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
  &__back {
    color: #1965EA;
    font-size: 12px;
  }
}
</style>
